// Starting lifecycle state for a fresh player.

import type { LifeState } from './types.js';

export function initialLifeState(): LifeState {
  return {
    schemaVersion: 1,
    age: 11, // Explorer bracket — old enough to recruit a Mastermind
    cash: 0,
    livingCosts: 50, // a kid's modest monthly outgoings — keeps Freedom Score well-defined
    assets: [],
    liabilities: [],
    mindset: { desire: 40, faith: 40, persistence: 40, focus: 40, gratitude: 40 },
    quadrant: 'E', // everyone starts as an Employee (pocket money / chores)
    visionBoard: [],
    mastermind: [],
    lastHarvestedWeek: 0,
    lastVisionBracket: 0,
    yearStart: { wealth: 0, freedomPct: 0, totalAssetValue: 0 },
    cashIdleYears: 0,
    learningProgress: { triggered: {}, answers: [] },
  };
}
